module.exports = __webpack_public_path__ + "media/video.004ccfef.mp4";